var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button, Checkbox, FormattedMessage, Grid, GridColumn, Icon, PageTitle, Table, ToastLevel, useIntl, useToast } from "@metsooutotec/modes-react-components";
import { observer } from "mobx-react-lite";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import sensorBatchStore from "../../../stores/ioT-stores/sensor-batch-store";
import { itemViewCellStyles, itemViewDetailsTableStyles, itemViewSubtitleStyles } from "../../common-style/common-style";
import { downloadFileFromBlobUrl } from "../../utils/files-utils";
import { getSensorBatchCsv, getSensorBatchPdf } from "../../../services/ioT-services/sensor-batch-service";
import SensorBatchModal from "./sensor-batch-modal";
import IotEntityDeleteModal from "../iot-devices-utils/iot-entity-delete-modal";
import ListView from "../../utils/list-view/list-view";
import TooltipBox from "../../common/tooltip-box";
import SensorImportModal from "../sensors/sensor-import-modal";
import GenerateSensorsModal from "../sensors/sensor-generate-sensors-modal";
import { IotDevicesModalTypes } from "../iot-devices-utils/iot-entity-modal-helper";
import SensorsToggleModal from "../sensors/sensors-toggle-modal";
import LowSpinner from "../../common/low-spinner";
import { convertDateToDDMMMYY, convertDateToDDMMMYYYY } from "../../utils/date-formatter-utils";
var SensorBatchView = observer(function () {
    var _a;
    var formatMessage = useIntl().formatMessage;
    var setMessage = useToast().setMessage;
    var navigate = useNavigate();
    var sensorBatchId = useParams().sensorBatchId;
    var location = useLocation();
    var sensorBatchMap = sensorBatchStore.sensorBatchMap;
    var sensorBatch = sensorBatchMap[sensorBatchId || ""];
    var _b = __read(useState([]), 2), sensorTable = _b[0], setSensorTable = _b[1];
    var failurCount = (_a = sensorBatch === null || sensorBatch === void 0 ? void 0 : sensorBatch.sensors) === null || _a === void 0 ? void 0 : _a.filter(function (s) { return s.fault; }).length;
    var params = location.state;
    var _c = params || {}, Created = _c.created, Edited = _c.edited;
    var _d = __read(useState(false), 2), isDeleteModalOpen = _d[0], setIsDeleteModalOpen = _d[1];
    var _e = __read(useState(false), 2), isSensorDeleteModalOpen = _e[0], setIsSensorDeleteModalOpen = _e[1];
    var _f = __read(useState(false), 2), isSensorImportModalOpen = _f[0], setIsSensorImportModalOpen = _f[1];
    var _g = __read(useState(null), 2), sensorToEdit = _g[0], setSensorToEdit = _g[1];
    var _h = __read(useState(null), 2), sensorToDelete = _h[0], setSensorToDelete = _h[1];
    var _j = __read(useState(false), 2), downloadLoading = _j[0], setDownloadLoading = _j[1];
    var _k = __read(useState(true), 2), loadingData = _k[0], setLoadingData = _k[1];
    var _l = __read(useState(false), 2), isEditModalOpen = _l[0], setIsEditModalOpen = _l[1];
    var _m = __read(useState(false), 2), isGenerateSensorsModalOpen = _m[0], setIsGenerateSensorsModalOpen = _m[1];
    var _o = __read(useState(false), 2), isLoadingButton = _o[0], setIsLoadingButton = _o[1];
    var _p = __read(useState(false), 2), isSensorsToggleOpen = _p[0], setIsSensorsToggleOpen = _p[1];
    var _q = __read(useState(null), 2), hoveredSensor = _q[0], setHoveredSensor = _q[1];
    var sensorBatchDate = convertDateToDDMMMYYYY(sensorBatch.batchDate);
    var showNotifier = function (text) {
        setMessage(text, ToastLevel.SUCCESS, 6000);
    };
    var loadSensorData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, sensorBatchStore.loadSensors(sensorBatchId, true)];
                case 1:
                    _b.sent();
                    failurCount = (_a = sensorBatch === null || sensorBatch === void 0 ? void 0 : sensorBatch.sensors) === null || _a === void 0 ? void 0 : _a.filter(function (s) { return s.fault; }).length;
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error('Error loading sensors:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadSensorData();
    }, []);
    useEffect(function () {
        var _a;
        if (sensorBatch === null || sensorBatch === void 0 ? void 0 : sensorBatch.sensors) {
            var sensorTableInit = (_a = sensorBatch === null || sensorBatch === void 0 ? void 0 : sensorBatch.sensors) === null || _a === void 0 ? void 0 : _a.map(function (sensor) {
                return __assign(__assign({}, sensor), { isChecked: false });
            });
            setSensorTable(sensorTableInit);
        }
        setLoadingData(true);
        setTimeout(function () {
            setLoadingData(false);
        }, 2000);
    }, [sensorBatch.sensors]);
    useEffect(function () {
        if (Created) {
            showNotifier("New Sensors created successfully");
        }
        if (Edited) {
            showNotifier("All changes made successfully");
        }
        window.history.replaceState({}, document.title);
    }, [Created, Edited, params]);
    var breadcrumbsPath = [
        {
            text: formatMessage('sensorBatchs.title'),
            to: "/sensor-batches"
        },
        {
            text: sensorBatchDate,
            to: "/sensor-batches/".concat(sensorBatch.id)
        },
    ];
    var downloadSensorBatchPdf = function () {
        setDownloadLoading(true);
        getSensorBatchPdf(sensorBatchId)
            .then(function (blobUrl) {
            if (blobUrl) {
                downloadFileFromBlobUrl(blobUrl, "SensorBatch_".concat(sensorBatchId, "-Pdf.pdf"));
            }
            else {
                setMessage("The requested file could not be found", ToastLevel.WARNING, 6000);
            }
        })
            .catch(function (err) {
            console.error('An error occurred:', err);
            setMessage("An error occurred while downloading the file", ToastLevel.ALERT, 6000);
        })
            .finally(function () {
            setDownloadLoading(false);
        });
    };
    var downloadSensorBatchCsv = function () {
        setDownloadLoading(true);
        getSensorBatchCsv(sensorBatchId)
            .then(function (blobUrl) {
            if (blobUrl) {
                downloadFileFromBlobUrl(blobUrl, "SensorBatch_".concat(sensorBatchId, "-Csv.csv"));
            }
            else {
                setMessage("The requested file could not be found", ToastLevel.WARNING, 6000);
            }
        })
            .catch(function (err) {
            console.error('An error occurred:', err);
            setMessage("An error occurred while downloading the file", ToastLevel.ALERT, 6000);
        })
            .finally(function () {
            setDownloadLoading(false);
        });
    };
    var editSensorBatchModal = {
        open: function () {
            setIsEditModalOpen(true);
        },
        close: function (passed, sensorBatchId, navigationCustomerOptions) {
            setIsEditModalOpen(false);
            if (passed) {
                navigate(location.pathname, {
                    state: navigationCustomerOptions
                });
            }
        }
    };
    var deleteSensorBatchModal = {
        open: function () {
            setIsDeleteModalOpen(true);
        },
        close: function (params) {
            setIsDeleteModalOpen(false);
            if (params.deleted) {
                navigate("/sensor-batches", { state: params });
            }
        }
    };
    var sensorsActionsHandlers = {
        open: function () {
            setIsSensorImportModalOpen(true);
        },
        edit: function (event, sensor) {
            event.stopPropagation();
            setSensorToEdit(sensor);
            setIsSensorImportModalOpen(true);
        },
        delete: function (event, sensor) {
            event.stopPropagation();
            if (sensor.commissionId || sensor.decommissionId || (sensor.telemetryData && sensor.telemetryData.hasTelemetries)) {
                setMessage("This sensor could not be deleted since it commtioned or has a telementries", ToastLevel.ALERT, 6000);
                return;
            }
            setSensorToDelete(sensor);
            setIsSensorDeleteModalOpen(true);
        },
        close: function (passed, sensorBatchId, navigationCustomerOptions) {
            setIsSensorImportModalOpen(false);
            setSensorToEdit(null);
            setIsGenerateSensorsModalOpen(false);
        },
        closeDelete: function (params) {
            setIsSensorDeleteModalOpen(false);
        },
        toggle: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selectedRows;
            return __generator(this, function (_a) {
                selectedRows = sensorTable.filter(function (s) { return s.isChecked; });
                if (selectedRows.length === 0)
                    return [2 /*return*/];
                setIsSensorsToggleOpen(true);
                return [2 /*return*/];
            });
        }); },
        generateSensors: function () {
            setIsGenerateSensorsModalOpen(true);
        }
    };
    var handleCheckboxChange = function (sensorId) {
        var updatedSensorTable = sensorTable === null || sensorTable === void 0 ? void 0 : sensorTable.map(function (sensor) {
            if (sensor.id === sensorId) {
                sensor.isChecked = !sensor.isChecked;
                return sensor;
            }
            return sensor;
        });
        setSensorTable(updatedSensorTable);
    };
    var toggleSelectAllSensors = function (isChecked) {
        sensorTable === null || sensorTable === void 0 ? void 0 : sensorTable.forEach(function (s) { return s.isChecked = isChecked; });
        setSensorTable(__spreadArray([], __read(sensorTable), false));
    };
    var template = [
        {
            headingKey: "",
            headingCellfun: function () { return _jsx(Checkbox, { checked: sensorTable.filter(function (s) { return s.isChecked; }).length === sensorTable.length, onChange: function (event, data) { return toggleSelectAllSensors(data.checked); } }); },
            cellFunc: function (s) { return _jsx(Checkbox, { checked: s.isChecked, onChange: function () { return handleCheckboxChange(s.id); } }); },
            isSearchable: false,
        },
        {
            headingKey: "headings.serialNumber",
            cellFunc: function (s) {
                return s.serialNumber;
            },
            isSearchable: true,
        },
        {
            headingKey: "headings.macAddress",
            cellFunc: function (s) { return s.macAddress; },
            isSearchable: true,
        },
        {
            headingKey: "headings.fault",
            cellFunc: function (s) { return (s.fault) ?
                _jsxs("span", __assign({ onMouseEnter: function () { return setHoveredSensor(s.serialNumber); }, onMouseLeave: function () { return setHoveredSensor(null); } }, { children: [hoveredSensor === s.serialNumber && _jsx(TooltipBox, { message: s.fault, position: { right: '0', left: '2em' } }), _jsx(Icon, { name: "icon-alarm-16", style: { color: "red" } })] })) : ""; },
        },
        {
            headingKey: "headings.isManufactured",
            cellFunc: function (s) { return _jsx(Checkbox, { checked: s.isManufactured, readOnly: true }); },
            isSearchable: false,
        },
        {
            headingKey: "headings.manufacturedDate",
            cellFunc: function (s) { var _a; return convertDateToDDMMMYY((_a = s.manufacturedDate) !== null && _a !== void 0 ? _a : null); },
            isSearchable: true,
        },
        {
            headingKey: "headings.firmwareVersion",
            cellFunc: function (s) { var _a; return (_a = s.telemetryData) === null || _a === void 0 ? void 0 : _a.firmwareVersion; },
            isSearchable: true,
        },
        {
            headingKey: "headings.wearDepth",
            cellFunc: function (s) { var _a; return (_a = s.telemetryData) === null || _a === void 0 ? void 0 : _a.wearDepth; },
            isSearchable: true,
        },
        {
            headingKey: "headings.lQI",
            cellFunc: function (s) { var _a; return (_a = s.telemetryData) === null || _a === void 0 ? void 0 : _a.lqi; },
            isSearchable: true,
        },
        {
            headingKey: "headings.date",
            cellFunc: function (s) { var _a; return ((_a = s.telemetryData) === null || _a === void 0 ? void 0 : _a.date) ? convertDateToDDMMMYY(s.telemetryData.date) : ""; },
            isSearchable: true,
        },
        {
            headingKey: "headings.actions",
            cellFunc: function (s) { return _jsxs("span", __assign({ style: { display: "flex", gap: "1.5em" } }, { children: [_jsx(Icon, { name: "icon-edit-16", onClick: function (event) { return sensorsActionsHandlers.edit(event, s); } }), _jsx(Icon, { name: "icon-trash-16", onClick: function (event) { return sensorsActionsHandlers.delete(event, s); } })] })); },
        }
    ];
    var rightPageButtons = (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ icon: "icon-trash-16", labelPosition: "right", onClick: deleteSensorBatchModal.open, secondary: true }, { children: formatMessage("sensorBatch.delete") })), _jsx(Button, __assign({ icon: "icon-edit-16", labelPosition: "right", onClick: editSensorBatchModal.open, primary: true }, { children: formatMessage("sensorBatch.edit") }))] }));
    var rightSensorButtons = (_jsxs("div", __assign({ style: { display: 'flex', gap: '0.5em' } }, { children: [_jsx(Button, __assign({ icon: "icon-submitted-16", labelPosition: "right", onClick: sensorsActionsHandlers.toggle, disabled: sensorTable.filter(function (s) { return s.isChecked; }).length === 0, loading: isLoadingButton }, { children: formatMessage("sensor.toggle") })), _jsx(Button, __assign({ icon: "icon-download-16", labelPosition: "right", onClick: sensorsActionsHandlers.generateSensors, loading: isLoadingButton, primary: true }, { children: formatMessage("sensor.generate") })), _jsx(Button, __assign({ icon: "icon-queued-16", labelPosition: "right", onClick: sensorsActionsHandlers.open, loading: isLoadingButton, primary: true }, { children: formatMessage("sensor.import") }))] })));
    var tableRows = [
        { header: "headings.batchDate", value: sensorBatchDate },
        { header: "headings.description", value: sensorBatch.description },
        { header: "headings.manufacturer", value: sensorBatch.manufacturer },
        { header: "headings.purchaseOrder", value: sensorBatch.purchaseOrder },
        { header: "headings.hardwareRevision", value: sensorBatch.hardwareRevision },
        { header: "headings.hardwareVariant", value: sensorBatch.hardwareVariant },
        { header: "headings.firmwareRevision", value: sensorBatch.firmwareRevision },
        { header: "headings.probeOffset", value: sensorBatch.probeOffset },
        { header: "headings.probeResolution", value: sensorBatch.probeResolution },
        { header: "headings.probeLength", value: sensorBatch.probeLength },
        { header: "headings.testResult", value: (!sensorBatch.isExistPdf) ? "Not Exist" : "testresult.pdf" },
        { header: "headings.mIBConfigs", value: (!sensorBatch.isExistCsv) ? "Not Exist" : "MIBConfigs.csv" },
    ];
    var tableContainerStyles = {
        borderTop: '2px solid gray',
        height: '91%'
    };
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { breadcrumbsPath: breadcrumbsPath, onPathChange: navigate, title: sensorBatchDate, extraItems: rightPageButtons }), _jsxs(Grid, __assign({ style: { height: "90%", width: "100%", paddingTop: "1em" } }, { children: [_jsxs(GridColumn, __assign({ style: { width: "25%", borderRight: "2px solid gray", paddingLeft: "2em" } }, { children: [_jsx("h3", __assign({ style: itemViewSubtitleStyles }, { children: _jsx(FormattedMessage, { id: "sensorBatch.details" }) })), _jsx(Table, __assign({ style: itemViewDetailsTableStyles, tight: true }, { children: _jsx(Table.Body, { children: tableRows.map(function (row, index) { return (_jsxs(Table.Row, { children: [_jsx(Table.HeaderCell, __assign({ style: itemViewCellStyles }, { children: _jsx(FormattedMessage, { id: row.header }) })), _jsx(Table.Cell, __assign({ style: itemViewCellStyles }, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: '10px' } }, { children: [_jsx("span", { children: row.value }), row.header === 'headings.testResult' && sensorBatch.isExistPdf && (_jsx(Button, { icon: "icon-download-16", onClick: downloadSensorBatchPdf, loading: downloadLoading, disabled: downloadLoading, primary: true })), row.header === 'headings.mIBConfigs' && sensorBatch.isExistCsv && (_jsx(Button, { icon: "icon-download-16", onClick: downloadSensorBatchCsv, loading: downloadLoading, disabled: downloadLoading, primary: true, style: { marginTop: "2px" } }))] })) }))] }, index)); }) }) }))] })), _jsxs(GridColumn, __assign({ style: { width: "75%", height: "100%", overflow: 'visible' } }, { children: [_jsxs("div", __assign({ style: { display: "flex", justifyContent: "space-between", alignItems: "flex-start" } }, { children: [_jsx("h3", __assign({ style: itemViewSubtitleStyles }, { children: _jsx(FormattedMessage, { id: "sensor.title" }) })), rightSensorButtons] })), "".concat(failurCount, " of ").concat(sensorTable === null || sensorTable === void 0 ? void 0 : sensorTable.length, " have failures."), _jsx("div", __assign({ style: tableContainerStyles }, { children: (loadingData)
                                    ? (_jsx(LowSpinner, { id: "sensor.loading" }))
                                    : ((sensorTable === null || sensorTable === void 0 ? void 0 : sensorTable.length) < 1)
                                        ?
                                            _jsx("span", { children: "No Data has been found" })
                                        : _jsx(ListView, { noneYetKey: "sensor.nonYet", template: template, data: sensorTable }) }))] }))] })), _jsx(SensorBatchModal, { isOpen: isEditModalOpen, sensorBatch: sensorBatch, onClose: editSensorBatchModal.close }), _jsx(IotEntityDeleteModal, { modalType: IotDevicesModalTypes.SensorBatchModal, entity: sensorBatch, onClose: deleteSensorBatchModal.close, isOpen: isDeleteModalOpen }), _jsx(IotEntityDeleteModal, { modalType: IotDevicesModalTypes.SensorModal, entity: sensorToDelete, onClose: sensorsActionsHandlers.closeDelete, isOpen: isSensorDeleteModalOpen }), _jsx(SensorImportModal, { isOpen: isSensorImportModalOpen, onClose: sensorsActionsHandlers.close, sensorBatchId: sensorBatchId, sensor: sensorToEdit !== null && sensorToEdit !== void 0 ? sensorToEdit : undefined }), _jsx(GenerateSensorsModal, { isOpen: isGenerateSensorsModalOpen, onClose: sensorsActionsHandlers.close, sensorBatchId: sensorBatchId }), _jsx(SensorsToggleModal, { isOpen: isSensorsToggleOpen, setIsOpen: setIsSensorsToggleOpen, sensorTable: sensorTable, setSensorsTable: setSensorTable })] }));
});
export default SensorBatchView;
